export const SET_MESSAGE = 'SET_MESSAGE';

export const setMessage = (message, severity) => {
  return {
    type: SET_MESSAGE,
    payload: { message: message, severity: severity },
    //valid severities: warning, error, info, success
  };
};

const initialState = {
  message: '',
  severity: '',
};

export const message = (state = initialState, action) => {
  switch (action.type) {
    case SET_MESSAGE:
      return action.payload;
    default:
      return state;
  }
};
